import { ReactNode } from 'react';
import { useMutation } from 'react-query';
import cn from 'classnames';
import { formatDate, isToday } from "@utils/formatValues";
import { INotificationItem, toggleFavorite } from '@api/apiClient/notifications';
import { Text, TextColor, TextWeight, TextSize } from '@components/Text';
import FireIcon from '@assets/icons/fire-red.svg?react';
import PricesIcon from '@assets/icons/prices.svg?react';
import NewsIcon from '@assets/icons/news.svg?react';
import StarIcon from '@assets/icons/star-empty.svg?react';
import styles from './NotificationItem.module.scss';

const icons: Record<string, ReactNode> = {
  Important: <FireIcon />,
  OffersAndPricing: <PricesIcon />,
  News: <NewsIcon />,
}

interface NotificationItemProps {
  data: INotificationItem;
  onClick: () => void;
  isActive?: boolean;
  updateItem: (data: INotificationItem) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = (
  { data, isActive, onClick, updateItem }
): React.ReactElement => {


  const { mutate: mutateToggleFavorite } = useMutation({
    mutationFn: toggleFavorite,
    onSuccess: () => {
      updateItem({ ...data, isFavorite: !data.isFavorite });
    }
  });

  return (
    <div
      className={cn(styles.root, isActive && styles.isActive)}
      onClick={onClick}
    >
      <div className={styles.inner}>
        <div className={styles.icons}>
          <StarIcon
              className={cn(styles.favorites, data.isFavorite && styles.favoritesActve)}
              onClick={(e) => {
                e.stopPropagation();
                mutateToggleFavorite(data.id);
              }}
          />
          <div className={styles.category}>{icons[data.category]}</div>
        </div>
        <div className={styles.titleColumn}>
          <Text size={TextSize.S} ellipsis lines={1} weight={data.isRead ? TextWeight.NORMAL : TextWeight.BOLD}>
            {data.title}
          </Text>
          <Text size={TextSize.XS} color={TextColor.DISABLED} ellipsis lines={2}>
            {data.description}
          </Text>
        </div>
      </div>
      <div className={styles.right}>
        <Text size={TextSize.XS} color={TextColor.DARK_MUTED}>
          {formatDate(data.pubDate, isToday(data.pubDate) ? "HH:mm" : "dd.MM.yy")}
        </Text>
        {data.isRead ? null : (<div className={styles.unreadMark} />)}
      </div>
    </div>
  );
};

export default NotificationItem;
